import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  padding: 0 20px;
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  @media only screen and (min-width: 768px) {
    padding: 0 30px;
  }
  @media only screen and (min-width: 1366px) {
    padding: 0 40px;
  }
`;

export const Wrapper = styled.div`
  --white: #ffffff;
  --light-grey: #eeeeee;
  --mid-grey: #cccccc;
  --mid-grey-highlight: #dddddd;
  --dark-grey: #666666;
  --dark-grey-highlight: #888888;
  --green: #7299a6;
  --green-highlight: #8bbcc2;
  --yellow: #febd36;
  --orange: #de6f00;
  --orange-highlight: #f68b1f;
  --danger: #da471f;
  --off-white: #f5f5f5;
  --border: #cccccc;
  -webkit-font-smoothing: antialiased;
  font-family: "Figtree", sans-serif;
  font-optical-sizing: auto;
  font-weight: 300;
  font-style: normal;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--dark-grey);
  display: flex;
  flex-direction: column;
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  .hide {
    visibility: hidden;
  }
  &.main {
    min-height: calc(var(--vh, 1vh) * 100);
    background-color: #ffffff;
  }
  .order-footer {
    border-top: 1px solid var(--border);
    .payment-method {
      min-width: 250px;
    }
  }
  .content {
    padding-bottom: 50px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  .add-to-cart-info {
    color: #7299a6;
    margin-left: 10px;
  }
  #design-placement {
    background-color: var(--dark-grey);
    opacity: 1;
    div.content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 8px;
      h3 {
        margin-top: 0;
        font-size: 1.125rem;
        font-weight: 700;
        color: var(--yellow);
      }
      span {
        font-size: 0.875rem;
        font-weight: 300;
      }
    }
  }
  .table-header {
    font-size: 0.8rem;
    font-weight: 700;
    display: flex;
    div {
      width: 15%;
      text-align: center;
    }
    &.products {
      justify-content: space-between;
      border-top: 1px solid var(--border);
      background-color: var(--off-white);
      .product-name-header {
        width: 30%;
      }
      .product-design-header {
        width: 15%;
      }
      .product-size-header {
        width: 10%;
      }
      .product-quantity-header {
        width: 10%;
      }
      .product-price-header {
        width: 10%;
      }
    }
  }
  h1,
  h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--dark-grey);
    margin-bottom: 20px;
    &.center {
      text-align: center;
      line-height: 1.875rem;
    }
  }
  h3 {
    font-size: 1rem;
    font-weight: 700;
    color: var(--dark-grey);
    margin: 30px 0 10px;
  }
  p {
    @media only screen and (max-width: 767px) {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }
  img.border {
    background-color: var(--white);
    padding: 4%;
    border: 1px solid var(--border) !important;
    border-radius: 5px;
  }
  a {
    text-decoration: none;
    color: var(--dark-grey);
    &.order-history-link {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.75rem;
      font-weight: 700;
      letter-spacing: 1px;
      border-radius: 100px;
      cursor: pointer;
      text-transform: uppercase;
      padding: 2px 15px;
      margin: 5px 0;
      line-height: 1.375rem;
      min-width: 150px;
      background-color: transparent;
      color: var(--dark-grey) !important;
      border: 1px solid var(--dark-grey);

      &:focus-visible {
        border-color: var(--orange-highlight) !important;
        box-shadow: none !important;
        outline-offset: 0 !important;
        border-radius: 100px !important;
        background-color: var(--orange-highlight) !important;
        color: #ffffff !important;
        outline: 2px solid var(--dark-grey) !important;
        outline-offset: 2px !important;
      }
    }
    &.text-link {
      &:focus-visible {
        outline: 2px solid var(--orange-highlight);
        border-radius: 5px;
        background-color: rgba(246, 139, 31, 0.15);
        box-shadow: 0 0 0 10px rgba(246, 139, 31, 0.15);
        outline-offset: 5px;
        color: var(--dark-grey) !important;
      }
    }
  }
  .cancel-order-confirmation {
    padding: 20px;
    text-align: center;
  }
  .small-print {
    font-size: 0.8rem;
    line-height: 1rem;
  }
  strong {
    font-weight: 700;
  }
  label {
    color: var(--dark-grey);
    font-size: 1rem;
    font-weight: 300;
    line-height: 1.0625rem;
    margin-bottom: 6px;
  }
  input,
  textarea,
  select {
    color: var(--dark-grey);
    line-height: normal;
    font-weight: 700;
    display: block;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--border);
    outline: none;
    &.quantity {
      width: 46px;
    }
    &:focus {
      border: 1px solid var(--orange-highlight);
      outline: 1px solid var(--orange-highlight);
      box-shadow: none;
    }
    &.is-invalid {
      border: 1px solid var(--danger);
      outline: 1px solid var(--danger);
      background-image: none !important;
      box-shadow: none !important;
      &:focus {
        border: 1px solid var(--danger);
        outline: 2px solid var(--orange-highlight);
        outline-offset: 2px;
      }
    }
  }
  input[type="text"],
  input[type="email"],
  select {
    padding: 15px;
  }
  input[type="checkbox"],
  input[type="radio"] {
    border-color: var(--green) !important;
    width: 1em !important;
    &:focus {
      outline: none !important;
    }
    &:focus-visible {
      outline: 2px solid var(--orange-highlight) !important;
    }
  }
  .form-group {
    text-align: left;
    select,
    input {
      margin-bottom: 20px;
    }
  }
  .sticky {
    position: sticky;
    top: 100px;
  }
  .box-padding {
    position: relative;
    padding: 30px;
    @media only screen and (max-width: 991px) {
      padding: 20px;
    }
  }
  .box-padding-2030 {
    position: relative;
    padding: 20px 30px;
    @media only screen and (max-width: 991px) {
      padding: 20px;
    }
  }
  .notice {
    display: flex;
    font-weight: 700;
    margin-bottom: 30px;
    background-color: var(--green);
    color: #fff;
    border-radius: 5px;
    font-size: 1.125rem;
    overflow: hidden;

    &.error {
      background-color: var(--danger);
    }
    .icon {
      font-size: 1.5rem;
      background-color: var(--dark-grey);
      padding: 0 20px;
      display: flex;
      align-items: center;
      i {
        color: var(--yellow);
      }
    }
    .text {
      padding: 20px;
    }
    span.usps-error-link {
      font-size: 1rem;
      font-style: italic;
      font-weight: 300;
      display: block;
    }
    a {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .return-bottom-bar {
    margin-top: 20px;
    &.shipping-fee,
    &.sales-tax {
      background-color: #f0f0f0;
      color: var(--dark-grey);
      margin-bottom: 10px;
    }
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 20px;
    font-size: 1.125rem;
    background-color: var(--green);
    color: var(--white);
    font-weight: 700;
    border-radius: 5px;
    text-align: right;
    span.text {
      font-size: 0.875rem;
      font-style: italic;
      font-weight: 300;
      margin-right: 20px;
    }
    span.amount {
      font-size: 1.125rem;
      font-weight: 700;
    }
    @media only screen and (max-width: 991px) {
      flex-wrap: wrap;
      justify-content: center;
      padding: 20px 0;
    }
  }
  .order-history-row {
    display: flex;
    margin-bottom: 0 !important;
    justify-content: space-between;
    border-top: 1px solid var(--border);
    padding: 20px 30px;
    line-height: 2.25rem;
    .order-history-image {
      width: 100px;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      img {
        width: 100%;
      }
      @media only screen and (max-width: 499px) {
        display: none;
      }
    }

    .order-history-buttons {
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      @media only screen and (max-width: 499px) {
        margin-top: 10px;
      }
    }
    &:first-child {
      border-top: 0;
    }

    .status {
      height: 36px;
      display: flex;
      align-items: center;
      span {
        display: flex !important;
        align-items: center;
        justify-content: center;
      }
    }
    .pending,
    .paid,
    .awaiting-refund,
    .refunded,
    .in-progress,
    .shipped,
    .completed,
    .cancelled,
    .returned,
    .refund {
      span {
        display: block;
        text-align: center;
        font-size: 0.75rem;
        line-height: 1.25rem;
        font-weight: 700;
        text-transform: uppercase;
        padding: 2px 0;
        border-radius: 5px;
        width: 130px;
      }
    }
    .pending {
      span {
        color: #666666;
        background-color: #febd36;
      }
    }

    .paid {
      span {
        color: #ffffff;
        background-color: #7299a6;
      }
    }

    .awaiting-refund {
      span {
        color: #666666;
        background-color: #febd36;
      }
    }

    .refunded {
      span {
        color: #ffffff;
        background-color: #666666;
      }
    }

    .shipped {
      span {
        color: #ffffff;
        background-color: #7fa574;
      }
    }

    .completed {
      span {
        color: #ffffff;
        background-color: #7299a6;
      }
    }

    .cancelled {
      span {
        color: #ffffff;
        background-color: #666666;
      }
    }

    .in-progress {
      span {
        color: #ffffff;
        background-color: #79b2d8;
      }
    }

    .returned {
      span {
        color: #ffffff;
        background-color: #de6f00;
      }
    }
    @media only screen and (max-width: 599px) {
      padding: 20px;
    }
    @media only screen and (max-width: 499px) {
      flex-direction: column;
      align-items: center;
    }
  }
  .order {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    & > div {
      width: 20%;
    }
  }
  .toast-error .toast-icon {
    background-color: var(--green) !important;
  }
  .upf50-logo {
    display: block;
    font-size: 2.8125rem;
    line-height: 100%;
    font-weight: 700;
    background-color: var(--dark-grey);
    color: var(--yellow);
    padding: 10px 15px;
    border-radius: 5px;
    width: fit-content;
    text-align: center;
    span {
      color: var(--green-highlight);
    }
    @media only screen and (max-width: 767px) {
      font-size: 1.75rem;
      padding: 8px 12px;
    }
    @media only screen and (min-width: 768px) {
      font-size: 2.25rem;
    }
    @media only screen and (min-width: 1150px) {
      font-size: 2.25rem;
    }
    @media only screen and (min-width: 1366px) {
      font-size: 2.8125rem;
    }
  }
  .gallery-container {
    min-height: calc(var(--vh, 1vh) * 100);
    a {
      cursor: pointer;
    }
    button {
      cursor: pointer;
      padding: 0px;
      border: none;
      background-color: transparent;
      position: relative;
      border-radius: 5px;
      img {
        width: 100%;
        border-radius: 5px;
      }
      &:focus-visible {
        outline: 3px solid var(--orange-highlight);
        outline-offset: 3px;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(246, 139, 31, 0.15);
          pointer-events: none;
          z-index: 1;
        }
        img {
          filter: contrast(1.15);
        }
      }
    }
    img {
      display: inline-block;
      width: 100%;
    }
    @media only screen and (max-width: 767px) {
      column-count: 2;
      column-gap: 10px;
      button {
        margin-bottom: 10px;
      }
    }
    @media only screen and (min-width: 768px) {
      column-count: 3;
      column-gap: 15px;
      button {
        margin-bottom: 15px;
      }
    }
    @media only screen and (min-width: 1150px) {
      column-count: 4;
      column-gap: 20px;
      button {
        margin-bottom: 20px;
      }
    }
  }
  .size-badge {
    .size-type {
      display: inline-block !important;
      background-color: var(--yellow) !important;
      color: var(--dark-grey) !important;
      border-radius: 2px !important;
      padding: 0px 6px !important;
      font-weight: 700 !important;
      margin-left: 6px !important;
      margin-right: 0 !important;
      line-height: 150% !important;
      &.reg {
        background-color: var(--green) !important;
        color: var(--white) !important;
      }
    }
  }
  .label-value-table {
    display: flex;
    .labels {
      display: flex;
      flex-direction: column;
      margin-right: 20px;
      text-align: right;
      font-weight: 300;
    }
    .values {
      display: flex;
      flex-direction: column;
      font-weight: 700;
      @media only screen and (min-width: 768px) {
        min-width: 80px;
      }
    }
  }
  .custom-toast {
    text-align: center;
    background-color: var(--white);
    padding: 20px;
    border: 1px solid var(--dark-grey);
    border-radius: 5px;
    h2 {
      margin-bottom: 0px;
    }
    p {
      margin: 10px 0;
    }
  }
  .product-row {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    .product-image {
      border-radius: 5px;
      background-color: var(--white);
      aspect-ratio: 1 / 1;
      border: 1px solid var(--border) !important;
      max-width: 200px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        display: block;
      }
      @media only screen and (max-width: 991px) {
        aspect-ratio: 1 / 1.25;
        max-width: 150px;
      }
      @media only screen and (max-width: 499px) {
        aspect-ratio: 1 / 0.75;
        max-width: initial;
      }
    }
    .product-block {
      flex-grow: 1;
      h2 {
        margin-bottom: 0;
        padding: 0 0 10px 0;
        font-size: 1.25rem;
      }
      .product-block-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        line-height: 200%;
        .product-block-label {
          z-index: 1;
          background-color: var(--white);
          padding-right: 10px;
        }
        .product-block-value {
          z-index: 1;
          font-weight: 700;
          text-align: right;
          background-color: var(--white);
          padding-left: 10px;
        }
        &:after {
          border: 1px dashed #dddddd;
          content: "";
          top: 50%;
          width: 100%;
          height: 1px;
          right: 0;
          display: block;
          position: absolute;
          z-index: 0;
        }
        &:last-child {
          margin-bottom: 0;
        }
        &.off-white {
          .product-block-label {
            background-color: var(--off-white);
          }
          .product-block-value {
            background-color: var(--off-white);
          }
          &:after {
            border: 1px dashed #cccccc;
          }
        }
      }
    }
    @media only screen and (max-width: 499px) {
      flex-direction: column;
      .product-image {
        width: 100% !important;
        img {
          width: 100% !important;
        }
      }
      .product-block {
        width: 100%;
      }
    }
  }
  &.modal-styles {
    margin: initial;
    overflow: hidden;
    border-radius: 5px;
    .fa-circle-info {
      border-radius: 100%;
      &:focus-visible {
        box-shadow: 0 0 0 2px #ffffff;
        outline: 2px solid var(--orange-highlight);
        outline-offset: 2px;
      }
    }
    .modal-title {
      text-transform: uppercase;
      font-size: 1rem;
      letter-spacing: 1px;
      img {
        width: 100px;
      }
    }

    &.cancel-order {
      @media only screen and (min-width: 576px) and (max-width: 767px) {
        border-radius: 5px;
      }
    }
    &.withPadding {
      .modal-body {
        padding: 20px;
      }
      button {
        &.full-width {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.75rem;
          font-weight: 700;
          color: var(--white);
          background-color: var(--green);
          padding: 8px 20px;
          border-radius: 5px;
          margin-top: 5px;
          margin-bottom: 5px;
          cursor: pointer;
          text-transform: uppercase;
          border: 0;
        }
        &.no-margins {
          margin: 0 !important;
        }
      }
    }
    .modal-header {
      background-color: var(--green);
      padding: 20px 30px !important;
      color: var(--white);
      border: 0;
      border-radius: 0 !important;
      .btn-close {
        box-shadow: none;
        opacity: 1;
        background-image: url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAxNiAxNicgZmlsbD0nIzY2Nic+PHBhdGggZD0nTS4yOTMuMjkzYTEgMSAwIDAgMSAxLjQxNCAwTDggNi41ODYgMTQuMjkzLjI5M2ExIDEgMCAxIDEgMS40MTQgMS40MTRMOS40MTQgOGw2LjI5MyA2LjI5M2ExIDEgMCAwIDEtMS40MTQgMS40MTRMOCA5LjQxNGwtNi4yOTMgNi4yOTNhMSAxIDAgMCAxLTEuNDE0LTEuNDE0TDYuNTg2IDggLjI5MyAxLjcwN2ExIDEgMCAwIDEgMC0xLjQxNHonLz48L3N2Zz4=");
        &:focus-visible {
          outline: 2px solid var(--white);
          filter: none;
          background-color: var(--orange-highlight);
        }
      }
      .slogan {
        color: var(--dark-grey);
        display: flex;
        align-items: center;
        font-size: 0.9rem;
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 1px;
        span {
          margin: 0 20px;
          background-color: var(--green);
          display: block;
          width: 3px;
          height: 30px;
        }
        @media only screen and (max-width: 1365px) {
          font-size: 0.9rem;
          line-height: 1.5rem;
        }
        @media only screen and (max-width: 550px) {
          & {
            flex-direction: column;
          }
          span {
            margin: 0 20px;
            background-color: var(--green);
            display: block;
            width: 100%;
            height: 3px;
          }
        }
      }
      @media only screen and (max-width: 767px) {
        padding: 20px !important;
      }
    }
    .modal-body {
      padding: 0;
      .return-review-template-products {
        margin-bottom: 50px;
      }
    }
    .modal-footer {
      border: 0;
      padding: 0;
      & > * {
        margin-left: 0;
        margin-right: 0;
      }
      &.buttons {
        flex-direction: column;
        align-items: stretch;
      }
    }
    &.navigation {
      border-radius: 0 !important;
      .modal-header {
        padding-top: 0;
        padding-bottom: 0;
        height: 70px;
        background-color: var(--off-white);
        border-radius: 0 !important;
        .btn-close {
          filter: invert(0);
          background-image: url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAxNiAxNicgZmlsbD0nIzY2Nic+PHBhdGggZD0nTS4yOTMuMjkzYTEgMSAwIDAgMSAxLjQxNCAwTDggNi41ODYgMTQuMjkzLjI5M2ExIDEgMCAxIDEgMS40MTQgMS40MTRMOS40MTQgOGw2LjI5MyA2LjI5M2ExIDEgMCAwIDEtMS40MTQgMS40MTRMOCA5LjQxNGwtNi4yOTMgNi4yOTNhMSAxIDAgMCAxLTEuNDE0LTEuNDE0TDYuNTg2IDggLjI5MyAxLjcwN2ExIDEgMCAwIDEgMC0xLjQxNHonLz48L3N2Zz4=");
        }
      }
    }
    .mobile-navigation {
      ul,
      li {
        margin: 0;
        padding: 0;
      }
      li {
        list-style-type: none;
        border-bottom: 1px solid var(--border);
      }
      a {
        padding: 15px 20px;
        display: block;
        cursor: pointer;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 0.75rem;
        &:hover {
          background-color: #f0f0f0;
        }
      }
    }
    .cancel-modal-content {
      text-align: center;
      padding: 20px;
      span {
        margin-bottom: 20px;
        display: block;
        font-weight: 700;
      }
      button {
        margin: 5px auto 10px;
      }
    }
  }
  .product-quantity-select {
    width: 100%;
    height: 36px;
    border: 1px solid #d8d5cf;
    background-color: #f8f8f6;
    font-size: 0.8rem;
    padding: 0 8px;
    cursor: pointer;
  }
`;

export const Announcements = styled.div`
  -webkit-font-smoothing: antialiased;
  background-color: #666666;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1px;
  line-height: 1.5rem;
  font-weight: 700;
  padding: 10px;
  text-align: center;
`;

export const NavigationBar = styled.div`
  color: var(--dark-grey);
  background-color: var(--off-white);
  .logo:focus-visible {
    background-color: rgba(246, 139, 31, 0.15);
    box-shadow: 0 0 0 4px rgba(246, 139, 31, 0.15);
    display: block;
    .header-logo {
      .st2 {
        fill: var(--orange-highlight) !important;
      }
    }
  }

  &.sticky-header-template {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1050;
    border-bottom: 1px solid var(--border);
  }
`;

export const NavigationItems = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  &.sticky-header-items {
    padding-top: 10px;
    padding-bottom: 10px;
    height: 55px !important;
    a {
      font-size: 0.8rem;
    }
    .sticky-logo-wrap {
      justify-content: flex-start;
      svg {
        width: 35px;
        margin-right: 20px;
      }
      .announcements {
        -webkit-font-smoothing: antialiased;
        color: var(--dark-grey);
        text-transform: uppercase;
        font-size: 0.8rem;
        letter-spacing: 1px;
        line-height: 1.5rem;
        font-weight: 700;
      }
    }
  }

  & > a {
    display: flex;
    align-items: center;
  }
  .slogan {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 1px;
    span {
      margin: 0 20px;
      background-color: var(--green);
      display: block;
      width: 3px;
      height: 30px;
    }
    @media only screen and (max-width: 1365px) {
      font-size: 0.9rem;
      line-height: 1.5rem;
    }
    @media only screen and (max-width: 550px) {
      & {
        flex-direction: column;
      }
      span {
        margin: 0 20px;
        background-color: var(--green);
        display: block;
        width: 100%;
        height: 3px;
      }
    }
  }
  .nav-menu {
    display: flex;
    justify-content: end;
    align-items: center;
    padding-right: 5px;
    a {
      padding-bottom: 0;
    }
    a.bag-link {
      margin-left: 10px;
      &:focus-visible {
        span {
          display: none;
        }
      }
    }
    a.account-link {
      margin: 0 10px;
      padding: 0;
      background-color: transparent;
    }
    a:focus-visible {
      border: none;
      outline: 2px solid var(--orange-highlight);
      background-color: rgba(246, 139, 31, 0.15);
      box-shadow: 0 0 0 10px rgba(246, 139, 31, 0.15);
      outline-offset: 5px;
      border-radius: 5px;
      color: #ffffff !important;
    }
    @media only screen and (max-width: 1365px) {
      font-size: 0.9rem;
    }
    @media only screen and (max-width: 1199px) {
      display: none;
    }
  }
`;

export const NavLinks = styled.div`
  a {
    margin: 0 10px;
    color: var(--dark-grey);
    font-weight: 700;
    text-transform: uppercase;
  }
`;

export const LogoRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  .fa-solid {
    font-size: 1.5rem;
    color: var(--green);
    margin-left: 20px;
  }
  a:last-child {
    margin-right: 0;
  }
`;

export const MenuButton = styled.div`
  display: none;
  cursor: pointer;
  text-align: right;
  i {
    color: var(--dark-grey);
    font-size: 1.5rem;
    margin-left: 0 !important;
  }
  @media only screen and (max-width: 1199px) {
    display: block;
  }
`;

export const LogoAndNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  svg {
    width: 150px;
    margin-right: 20px;
  }
  @media only screen and (max-width: 1365px) {
    width: auto;
    svg {
      width: 120px;
    }
  }
`;

export const HomeHeroImage = styled.div`
  .banner-tablet,
  .banner-desktop,
  .banner-mobile {
    img {
      width: 100%;
    }
  }
  @media only screen and (max-width: 767px) {
    aspect-ratio: 767 / 464;
    .banner-mobile {
      display: block;
    }
    .banner-tablet,
    .banner-desktop {
      display: none;
    }
  }
  @media only screen and (min-width: 768px) {
    aspect-ratio: 991 / 400;
    .banner-tablet {
      display: block;
    }
    .banner-mobile,
    .banner-desktop {
      display: none;
    }
  }
  @media only screen and (min-width: 992px) {
    aspect-ratio: 1710 / 517;
    .banner-desktop {
      display: block;
    }
    .banner-tablet,
    .banner-mobile {
      display: none;
    }
  }
`;

export const HomeHeroRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: var(--white);
  padding-top: 20px;
  padding-bottom: 20px;
  & > div {
    margin: 20px 0 15px 0;
  }
  @media only screen and (min-width: 992px) {
    flex-direction: row;
    padding: 50px 0;
    margin: 0 auto;
    & > div {
      margin: 0 30px;
    }
  }
  @media only screen and (min-width: 1366px) {
    padding: 60px 0;
    margin: 0 auto;
    & > div {
      margin: 0 50px;
    }
  }
`;

export const HomeHeroText = styled.div`
  text-align: center;
  div.hero-text-top {
    display: flex;
    align-items: center;
    justify-content: center;
    span.upf50-logo {
      margin-right: 15px;
    }
    @media only screen and (max-width: 991px) {
      flex-direction: column;
      span.upf50-logo {
        margin-bottom: 12px;
        margin-right: 0;
      }
    }
    @media only screen and (max-width: 767px) {
      span.upf50-logo {
        margin-bottom: 8px;
      }
    }
  }
  span {
    &.upf50-text {
      display: block;
      font-size: 1.75rem;
      line-height: 100%;
      font-family: "Figtree", sans-serif;
      color: var(--dark-grey);
      font-weight: 700;
      text-transform: uppercase;
    }
    &.hero-text-bottom {
      display: block;
      font-size: 1.75rem;
      line-height: 100%;
      font-family: "Damion", sans-serif;
      color: var(--green);
      font-weight: 300;
      @media only screen and (max-width: 500px) {
        font-size: 1.625rem;
      }
    }
    &.upf50-text {
      @media only screen and (min-width: 768px) {
        font-size: 2.25rem;
      }
      @media only screen and (min-width: 1366px) {
        font-size: 2.8125rem;
      }
    }
    &.hero-text-bottom {
      @media only screen and (min-width: 500px) {
        font-size: 2.25rem;
      }
      @media only screen and (min-width: 768px) {
        font-size: 2.8125rem;
      }
      @media only screen and (min-width: 991px) {
        font-size: 3.625rem;
      }
      @media only screen and (min-width: 1366px) {
        font-size: 4.5rem;
      }
    }
  }
`;

export const Story = styled.div`
  background-color: var(--dark-grey);
  padding: 30px;
  text-align: center;
  font-family: "Figtree", sans-serif;
  font-weight: 700;
  display: flex;
  align-items: center;
  h2 {
    font-style: italic;
    text-align: center;
    font-size: 1.125rem;
    line-height: 1.875rem;
    max-width: 1200px;
    margin: 0 auto;
    color: var(--mid-grey);
    span {
      color: var(--yellow);
      white-space: nowrap;
      span {
        color: var(--green-highlight);
      }
    }
  }
  img.logo {
    width: 100px;
    margin-right: 40px;
    display: block;
  }
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    h2 {
      max-width: 550px;
    }
    img.logo {
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
  @media only screen and (min-width: 768px) {
    h2 {
      font-size: 1.5rem;
      line-height: 2.25rem;
    }
    img.logo {
      width: 180px;
      margin-right: 20px;
    }
    padding: 50px;
  }
  @media only screen and (min-width: 992px) {
    padding: 50px 100px;
    margin-top: 0;
  }
  @media only screen and (min-width: 1150px) {
    padding: 50px 150px;
  }
  @media only screen and (min-width: 1366px) {
    h2 {
      font-size: 1.875rem;
      line-height: 2.8125rem;
    }
    padding: 50px 16%;
  }
`;

export const Details = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px 0;
  font-size: 1.25rem;
  line-height: 1.875rem;
  background-color: var(--white);
  color: var(--dark-grey);

  div.details-content {
    padding: 0 25px 0 50px;
    width: 50%;
    @media only screen and (max-width: 1365px) {
      padding: 0 15px 0 30px;
    }
    @media only screen and (min-width: 992px) and (max-width: 1129px) {
      width: 60%;
    }
  }

  div.details-graphic {
    padding: 0 50px 0 25px;
    width: 50%;
    display: flex;
    justify-content: space-between;
    @media only screen and (max-width: 1365px) {
      padding: 0 30px 0 15px;
    }
    .designed-for-outdoors {
      background-image: url(https://assets.greygullapparel.com/banners/designed-for-outdoors.jpg);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 90%;
      width: calc(50% - 15px);
      margin-right: 30px;
      border-radius: 5px;
      height: 450px;
    }
    a {
      margin: 30px auto;
    }
    .homepage-size-chart {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: calc(50% - 15px);
      background-color: var(--mid-grey);
      border-radius: 5px;
      .homepage-size-chart-columns {
        display: flex;
        .homepage-size-chart-column {
          width: 50%;
        }
      }
      p {
        font-size: 1.5rem;
        text-align: center;
        font-weight: 700;
        margin-top: 20px;
        color: var(--dark-grey);
      }
      .size-heading {
        background-color: var(--dark-grey);
        text-align: center;
        padding: 10px;
        span {
          text-align: center;
          padding: 10px 0;
          font-weight: 700;
          &.regular {
            color: var(--green-highlight);
          }
          &.short {
            color: var(--yellow);
          }
        }
      }
      .size-values {
        padding: 0 10px;
        ul {
          margin: 0;
          padding: 0;
          margin-top: 10px;
          li {
            display: list-item;
            list-style: none;
            padding: 10px 0 0 0;
            text-align: center;
            color: var(--dark-grey);
            font-weight: 700;
            &:before {
              margin: 0;
            }
          }
        }
      }
      .short {
        padding-left: 25%;
      }
      .reg {
        padding-right: 25%;
      }
    }
    @media only screen and (min-width: 1366px), screen and (min-width: 768px) and (max-width: 991px) {
      .designed-for-outdoors {
        width: calc(60% - 15px);
      }
      .homepage-size-chart {
        width: calc(40% - 15px);
      }
    }
    @media only screen and (min-width: 992px) and (max-width: 1129px) {
      .designed-for-outdoors {
        background-size: 145%;
        background-position: top right;
      }
      .size-heading.reg {
        margin-top: 10px;
      }
    }

    @media only screen and (max-width: 767px) {
      font-size: 1rem;
      .designed-for-outdoors {
        margin-right: 20px;
      }
      .designed-for-outdoors,
      .homepage-size-chart {
        width: calc(50% - 10px);
      }
    }

    @media only screen and (min-width: 1130px) {
      .designed-for-outdoors {
        height: 650px;
        background-position: 88%;
      }
    }

    @media only screen and (min-width: 1366px) {
      .designed-for-outdoors {
        height: 600px;
        background-position: 88%;
      }
    }

    @media only screen and (min-width: 992px) and (max-width: 1129px), screen and (max-width: 499px) {
      width: 40%;
      flex-direction: column;
      .designed-for-outdoors {
        width: 100%;
        margin-left: 0;
        margin-bottom: 30px;
        height: 300px;
        background-size: 145%;
        background-position: top right;
      }
      .homepage-size-chart {
        width: 100%;
        .homepage-size-chart-columns {
          flex-direction: column;
          .homepage-size-chart-column {
            width: 100%;
            .short,
            .reg {
              padding: 5px;
            }
            ul {
              display: flex;
              justify-content: center;
              margin: 0;
            }
            li {
              display: inline;
              padding: 0 10px;
            }
          }
        }
        a {
          margin: 10px auto 20px auto;
        }
      }
      @media only screen and (min-width: 1130px) {
        width: 50%;
        flex-direction: row;
      }
    }
    @media only screen and (max-width: 499px) {
      .designed-for-outdoors {
        height: 250px;
        background-size: 145%;
        background-position: 100% 20%;
      }
      .homepage-size-chart {
        font-size: 0.875rem;
        .size-values {
          padding: 5px 0;
        }
        p {
          font-size: 1.125rem;
        }
      }
    }
  }

  h3 {
    font-size: 3.125rem;
    line-height: 3.75rem;
    font-weight: 300;
    text-align: center;
    font-family: "Damion", sans-serif;
    color: var(--dark-grey);
    margin: 0 0 25px 0;
    border-bottom: 2px solid var(--green);
    padding-bottom: 20px;
    &.available-size-title {
      margin-top: 50px;
    }
  }

  @media only screen and (max-width: 991px) {
    flex-direction: column;
    div.details-content,
    div.details-graphic {
      width: 100%;
      padding: 0 30px;
    }
    div.details-content {
      padding-bottom: 20px;
      h3 {
        margin-bottom: 15px;
      }
      p {
        margin-bottom: 20px;
      }
    }
    padding: 30px 0;
  }
  @media only screen and (max-width: 767px) {
    div.details-content,
    div.details-graphic {
      padding: 0 20px;
    }
    div.details-content {
      h3 {
        margin-bottom: 20px;
        padding-bottom: 15px;
      }
      p {
        margin-bottom: 20px;
      }
    }
  }
  @media only screen and (max-width: 599px) {
    h3 {
      font-size: 2.5rem;
      line-height: 3.125rem;
      padding-bottom: 10px;
      margin-bottom: 15px;
    }
    p {
      margin-bottom: 15px;
    }
  }
  @media only screen and (max-width: 499px) {
    h3 {
      font-size: 1.875rem;
      line-height: 2.5rem;
    }
  }
  @media only screen and (min-width: 1366px) {
    div.details-content {
      width: 50%;
    }
    div.details-graphic {
      width: 50%;
    }
  }
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--white);
  background-color: var(--green);
  border-radius: 100px;
  padding: 8px 20px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  text-transform: uppercase;
  border: 0;
  &.stacked-button {
    background-color: var(--white);
    color: var(--dark-grey);
    border: 1px solid var(--border);
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 15px;
    font-size: 0.875rem;
    width: 100%;
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      background-color: var(--green);
      border: 1px solid var(--green);
      color: var(--white);
    }
  }
  &.green {
    background-color: var(--green);
    color: var(--white);
  }
  &.grey {
    background-color: var(--dark-grey);
  }
  &.lightgrey {
    background-color: var(--mid-grey);
  }
  &.yellow {
    background-color: var(--yellow);
    color: var(--dark-grey);
    &:focus-visible {
      outline-offset: 3px !important;
    }
  }
  &.green-highlight {
    background-color: var(--green-highlight);
    color: var(--dark-grey) !important;
  }
  &.clear {
    background-color: transparent;
    color: var(--dark-grey) !important;
    border: 1px solid var(--dark-grey);
    &:focus-visible {
      border-color: var(--orange-highlight) !important;
    }
  }
  .fa-cart-shopping {
    margin-right: 6px;
  }
  i {
    font-size: 1rem;
  }
  &.autoWidth {
    display: inline-block;
  }
  &.white {
    background-color: var(--white);
    color: var(--dark-grey) !important;
    &:focus-visible {
      outline: 2px solid var(--white) !important;
      outline-offset: 3px !important;
    }
  }
  &.small {
    font-size: 0.75rem;
    padding: 2px 15px;
    line-height: 1.5rem;
  }
  &.large {
    font-size: 1rem;
  }
  &.order-history-link {
    padding: 2px 15px;
    margin: 5px 0;
    line-height: 1.375rem;
    min-width: 150px;
  }
  &.textWithIcon {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 0 0 auto !important;
    color: var(--dark-grey);
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.8125rem;
    border: 0;
    background-color: transparent !important;
    letter-spacing: 0;
    padding: 0;
    i {
      margin-right: 6px;
    }
    &:focus-visible {
      outline: 2px solid var(--orange-highlight);
      outline-offset: 5px;
      border-radius: 5px;
      background-color: transparent !important;
      color: var(--dark-grey) !important;
    }
  }
  &.add-to-cart-button {
    justify-self: end;
    margin-top: 20px;
  }
  &.on-dark-bg {
    &:focus-visible {
      outline-color: var(--white) !important;
    }
  }
  &:focus-visible {
    background-color: var(--orange-highlight) !important;
    color: var(--white) !important;
    outline: 2px solid var(--dark-grey);
    outline-offset: 2px;
    box-shadow: none;
  }
`;

export const ButtonLink = styled(Link)`
  text-decoration: none;
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--white) !important;
  background-color: var(--green);
  padding: 8px 20px;
  border-radius: 100px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  text-align: center;
  text-transform: uppercase;
  &.grey {
    background-color: var(--dark-grey);
  }
  &.lightgrey {
    background-color: var(--mid-grey);
  }
  &.yellow {
    background-color: var(--yellow);
    color: var(--dark-grey) !important;
    &:focus-visible {
      outline-color: var(--white);
      outline-offset: 3px;
    }
  }
  &.green-highlight {
    background-color: var(--green-highlight);
    color: var(--dark-grey) !important;
  }
  &.clear {
    background-color: transparent;
    color: var(--dark-grey) !important;
    border: 1px solid var(--dark-grey);
    &:focus-visible {
      border-color: var(--orange-highlight) !important;
    }
  }
  &.white {
    background-color: var(--white);
    color: var(--dark-grey) !important;
  }
  &.autoWidth {
    display: inline-block;
  }
  &.small {
    font-size: 0.75rem;
    padding: 2px 15px;
    line-height: 1.5rem;
  }
  &.large {
    font-size: 1rem;
  }
  &.autoFitCenter {
    width: fit-content;
    margin: 0 auto;
  }
  &.order-history-link {
    padding: 2px 15px;
    margin: 5px 0;
    line-height: 1.375rem;
    min-width: 150px;
  }
  &:focus-visible {
    background-color: var(--orange-highlight) !important;
    color: var(--white) !important;
    outline: 2px solid var(--dark-grey);
    outline-offset: 2px;
    box-shadow: none;
  }
`;

export const ActionLink = styled.div`
  text-decoration: none;
  color: var(--dark-grey);
  cursor: pointer;
`;

export const CartIcon = styled(Link)`
  position: relative;
  span {
    font-size: 0.75rem;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -5px;
    right: -10px;
    background-color: var(--green);
    border-radius: 100px;
    color: var(--white);
    width: 20px;
    height: 20px;
  }
`;

export const HeaderTemplate = styled(Container)`
  .header {
    min-height: 50px;
    margin-top: 50px;
    margin-bottom: 20px;
    border-bottom: 1px solid var(--border);
    .title {
      color: var(--dark-grey);
      display: flex;
      height: 50px;
      align-items: center;
      h1 {
        font-family: "Figtree", sans-serif;
        font-weight: 700;
        font-size: 1.375rem;
        margin-bottom: 0;
        padding-bottom: 0;
        text-align: right;
      }
    }
    .breadcrumb {
      padding: 20px 0 0;
      a:focus-visible {
        outline: 2px solid var(--dark-grey);
        outline-offset: 2px;
      }
    }
    .content {
      display: flex;
      justify-content: start;
      align-items: center;
      padding: 20px 0;
      color: var(--dark-grey);
      h1 {
        padding: 0;
        margin: 0;
        margin-right: 50px;
      }
    }
    &.flex-header {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .title,
      .breadcrumb {
        padding: 0;
        margin: 0;
      }
      h1 {
        margin-right: 15px;
      }
    }
    &.no-line {
      border-bottom: 0;
      margin-bottom: 10px;
    }
    @media only screen and (max-width: 991px) {
      margin-top: 30px;
    }
    @media only screen and (max-width: 499px) {
      justify-content: space-between !important;
      margin-top: 20px;
    }
  }
  &.narrow {
    max-width: 1200px;
  }
`;

export const PageTemplate = styled(Container)`
  &.no-header {
    margin-top: 50px;
  }
  &.order-lookup {
    padding: 0 20px;
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;
    @media only screen and (min-width: 768px) {
      padding: 0 30px;
    }
    @media only screen and (min-width: 1366px) {
      padding: 0 40px;
    }
  }
  .size-guide {
    display: flex;
    align-items: stretch;
    gap: 20px;
    .shirt-size-graphic {
      width: 400px;
      background-color: var(--white);
      border: 1px solid var(--border);
      min-height: 100%;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      img {
        width: 100%;
        max-width: 500px;
      }
    }
    .size-chart {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      .size-chart-border {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        overflow: hidden;
      }
      .size-chart-bottom {
        background-color: var(--white);
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border: 1px solid var(--border);
        border-top: 0;
        text-align: center;
        padding: 20px;
        font-style: italic;
        font-size: 0.875rem;
        flex-grow: 1;
      }
    }
    .size-chart-info {
      border: 1px solid var(--border);
      border-radius: 5px;
      font-size: 0.8rem;
      font-style: italic;
      padding: 20px;
      width: 250px;
    }
  }

  .columns {
    display: flex;
    justify-content: space-between;
    .left-column,
    .right-column {
      width: 50%;
      .productTitlePrice {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        h1 {
          font-family: "Figtree", sans-serif;
          font-weight: 700;
          font-size: 1.375rem;
          margin-bottom: 0;
          padding-bottom: 0;
          @media only screen and (max-width: 767px) {
            font-size: 1.125rem;
          }
        }
        .price {
          flex-grow: 1;
          text-align: right;
          font-weight: 700;
          font-size: 1.375rem;
        }
      }
      .color-options {
        margin-bottom: 20px;
      }
    }
    .left-column {
      margin-right: 50px;
    }
    &.success {
      padding-top: 20px;
      .left-column {
        width: 100%;
      }
      .right-column {
        padding: 30px 0;
        width: fit-content;
        white-space: nowrap;
      }
    }
    &.checkout {
      input {
        background-color: var(--off-white);
      }
      .left-column {
        width: 60%;
      }
      .right-column {
        width: 40%;
        @media only screen and (max-width: 991px) {
          margin-top: 30px;
        }
      }
    }

    &.product-page {
      .left-column {
        flex-grow: 1;
        .product-images {
          min-height: 1600px;
          margin-bottom: 20px;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          .product-image-tile {
            overflow: hidden;
            cursor: zoom-in;
            background-color: var(--off-white);

            img {
              width: 100%;
              height: 100%;
              display: block;
              object-fit: cover;
              transform-origin: var(--zoom-x, 50%) var(--zoom-y, 50%);
              transition: transform 0.25s ease;
            }

            &.zoomed {
              cursor: zoom-out;

              img {
                transform: scale(1.75);
              }
            }
          }
        }

        .mobile-product-slider {
          display: none;
        }
      }
      .right-column {
        width: 450px;
        max-width: 600px;
        margin: 0 auto;
        .product-option-box {
          overflow: visible;
          position: sticky;
          top: 100px;
          padding-bottom: 50px;
          -webkit-transition: all ease-in-out 0.5s;
          transition: all ease-in-out 0.5s;
          .right-bar-label {
            text-transform: uppercase;
            margin: 30px 0 10px 0;
            font-size: 0.8rem;
          }
          .detail-list {
            list-style: none;
            padding-left: 20px;
            li {
              text-indent: -20px;
              font-size: 0.9rem;
              line-height: 200%;
            }
            li::before {
              content: "- ";
            }
          }
        }

        .product-title {
          font-size: 1.5rem;
          font-weight: 700;
          margin: 10px 0 10px 0;
        }

        .product-style-code {
          font-size: 1rem;
          font-weight: 300;
          margin: 10px 0 30px 0;
        }

        .product-cost {
          font-size: 1rem;
          font-weight: 600;
          padding-bottom: 30px;
          &.discounted {
            color: var(--danger);
            .retail-price {
              color: var(--dark-grey);
              text-decoration: line-through;
              padding: 0 5px;
              font-weight: 400;
            }
          }
        }

        .product-color-options {
          display: flex;
          align-items: center;
        }

        .product-color-button {
          width: 30px;
          height: 30px;
          margin-right: 10px;
          cursor: pointer;
        }

        .product-color-button.selected {
          border: 2px solid var(--white);
          outline: 2px solid var(--dark-grey);
        }

        .product-color-button.unselected {
          border: 2px solid #ffffff;
        }

        .option-selector {
          padding: 0 0 30px 0;
        }

        .option-label {
          text-transform: uppercase;
          margin-bottom: 10px;
          font-size: 0.8rem;
        }

        .option-selected {
          margin-left: 8px;
        }

        .product-size-options {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .product-size-option {
          min-width: 45px;
          height: 42px;
          border: 2px solid var(--light-grey);
          background-color: var(--white);
          color: #777777;
          font-size: 1rem;
          font-weight: 700;
          cursor: pointer;
          text-transform: uppercase;
        }

        .product-size-option.selected {
          border: 2px solid var(--white);
          outline: 2px solid var(--dark-grey);

          background-color: var(--light-grey);
        }

        .product-size-option.xxl {
          min-width: 55px;
        }

        .product-add-to-bag.disabled {
          cursor: not-allowed;
          opacity: 1;
        }

        .product-size-chart-link {
          background: none;
          border: none;
          font-size: 0.875rem;
          text-decoration: underline;
          cursor: pointer;
          color: #6f6f6f;
          margin-top: 10px;
          margin-bottom: -10px;
          padding: 0;
        }

        .product-purchase-row {
          display: flex;
          gap: 10px;
          align-items: stretch;
          padding: 20px 0 0 0;
        }

        .product-quantity-box {
          width: 46px;
          min-width: 46px;
        }

        .product-add-to-bag {
          flex: 1;
          height: 36px;
          border: none;
          color: #ffffff;
          font-weight: 700;
          letter-spacing: 0.08em;
          margin: 0;
        }

        .product-add-to-bag.enabled {
          background-color: var(--green);
          cursor: pointer;
        }

        .product-add-to-bag.disabled {
          background-color: #8a8a8a;
          cursor: not-allowed;
        }
      }
    }
    @media only screen and (max-width: 991px) {
      flex-direction: column;

      &.product-page {
        .left-column {
          margin-right: 0;

          .desktop-product-images {
            display: none;
          }

          .mobile-product-slider {
            display: block;
            width: 100%;
            margin-bottom: 20px;
          }

          .mobile-product-slide {
            width: 100%;
            overflow: hidden;
            background-color: var(--off-white);
            touch-action: pan-y;
            user-select: none;
            -webkit-user-select: none;

            img {
              display: block;
              width: 100%;
              height: auto;
              object-fit: cover;
              pointer-events: none;
            }
          }

          .mobile-product-slider-dots {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            padding: 16px 0 4px;
          }

          .mobile-product-slider-dot {
            width: 8px;
            height: 8px;
            min-width: 8px;
            padding: 0;
            border: 1px solid #777777;
            border-radius: 0;
            background: transparent;
            cursor: pointer;
          }

          .mobile-product-slider-dot.active {
            background: #777777;
          }
        }
      }
      &.success {
        flex-direction: column-reverse;
        .left-column {
          margin-right: 0;
        }
        .right-column {
          margin-bottom: 30px;
          padding: 20px 0;
        }
      }
      .left-column,
      .right-column {
        width: 100% !important;
        padding-right: 0;
      }
    }
  }
  .start-return {
    margin-bottom: 30px;
  }
  .start-return-exchange-row {
    background-color: var(--white);
    overflow: hidden;
    .return-exchange-product {
      .form-check {
        margin-bottom: 0;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      input[type="checkbox"] {
        border-color: var(--green) !important;
        width: 1.5em !important;
        height: 1.5em !important;
      }
      input:checked {
        background-color: var(--green) !important;
        border-color: var(--green) !important;
      }
      padding: 30px 30px 10px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media only screen and (max-width: 991px) {
        padding: 20px;
      }

      @media only screen and (max-width: 767px) {
      }

      @media only screen and (max-width: 499px) {
        padding: 15px 0;
        .return-exchange-checkbox {
          background-color: var(--green);
          align-self: stretch;
          margin-right: 20px;
          border-radius: 5px;
          .form-check {
            margin-right: 0;
            height: 100%;
            width: 50px;
            align-items: center;
          }
        }
      }
    }
    .return-exchange-dropdowns {
      border-radius: 5px;
      margin-top: 20px;
      &.hide {
        display: none;
      }
      &.error {
        background-color: var(--danger);
      }
      background-color: var(--light-grey);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 30px;
      select {
        padding-right: 40px;
      }
      .refund-amount {
        line-height: 1.125rem;
        font-weight: 700;
        span {
          margin-left: 20px;
        }
      }
      .left-return-options {
        display: flex;
      }
      .right-return-options {
        flex-grow: 1;
        text-align: right;
      }
      @media only screen and (max-width: 991px) {
        padding: 15px 20px;
        & > div {
          width: 250px;
          .exchange-dropdowns {
            flex-direction: column;
          }
        }
        .left-return-options {
          flex-direction: column;
          .return-type {
            margin-bottom: 15px;
          }
        }
        .right-return-options {
          #sizeExchange {
            margin-bottom: 15px;
          }
        }
      }
      @media only screen and (max-width: 767px) {
        flex-direction: column;
        padding: 25px;
        .refund-amount {
          text-align: center;
        }
        & > div {
          width: 250px;
          & select#sizeExchange,
          & select#positionExchange,
          & .refund-amount {
            margin-top: 15px;
          }
        }
      }
      @media only screen and (max-width: 499px) {
        margin-top: 0;
        margin-bottom: 20px;
      }
      @media only screen and (min-width: 992px) {
        .return-type {
          margin-right: 20px;
        }
      }
    }
    @media only screen and (min-width: 768px) {
      .exchange-dropdowns {
        display: flex;
        place-self: flex-end;
        select {
          width: auto;
        }
      }
    }
  }
  &.narrow {
    max-width: 1200px;
  }
  .order-search {
    display: flex;
    margin-top: 0;
    margin-bottom: 40px;
    justify-content: space-between;
    align-items: center;
    background-color: var(--white);
    border-radius: 5px;
    padding: 10px 0;
    .form-group {
      display: flex;
      align-items: center;
      flex-grow: 1;
      input {
        margin-bottom: 0;
        margin-right: 30px;
        flex-grow: 1;
        font-weight: 300;
        background-color: var(--off-white);
      }
    }
    button {
      justify-self: end;
      padding: 4px 40px;
      margin-left: 20px;
    }
    @media only screen and (max-width: 767px) {
      flex-direction: column;
      .form-group {
        width: 100%;
        margin-bottom: 20px;
      }
      button {
        margin-left: 0;
      }
      input {
        margin-right: 0 !important;
      }
    }
  }
  .order-lookup-result {
    border: 1px solid var(--border);
    overflow: hidden;
    .order-history-row {
      border-bottom: 1px solid var(--border);
      background-color: var(--off-white);
    }
    @media only screen and (min-width: 500px) {
      border-radius: 5px;
    }
  }
  .return-confirmation-title {
    background-color: var(--dark-grey-highlight);
    border-radius: 5px;
    color: var(--white);
    margin-bottom: 20px;
    h2 {
      color: var(--white);
      padding-bottom: 0;
      margin-bottom: 10px;
    }
    p {
      margin-bottom: 0;
    }
    @media only screen and (max-width: 767px) {
      font-size: 1.125rem;
    }
  }
  .centered-icon {
    width: 50px;
    margin: 20px auto 10px auto;
    display: block;
  }
  .content-page {
    background-color: var(--white);
    border-radius: 5px;
    &.grey {
      background-color: var(--dark-grey);
    }
    &.user-verification-message {
      text-align: center;
      h2 {
        margin-bottom: 5px;
        text-transform: capitalize;
        &.success {
          color: var(--green);
        }
        &.failed {
          color: var(--danger);
        }
      }
    }
    @media only screen and (max-width: 991px) {
      padding: 25px 20px 20px;
    }
  }
  .content-page-form {
    input,
    textarea,
    label {
      padding: 20px 30px;
      @media only screen and (max-width: 991px) {
        padding: 20px;
      }
    }
  }
  &.policy {
    padding-top: 20px;
    h2 {
      font-size: 1.25rem;
      margin-top: 40px;
      font-weight: 700;
    }
    h3 {
      font-size: 1.25rem;
      font-weight: 700;
    }
    a {
      color: var(--green);
      text-decoration: underline;
    }
    table {
      margin-bottom: 40px;
      @media only screen and (max-width: 767px) {
        font-size: 0.875rem;
        line-height: 1.25rem;
      }
      @media only screen and (max-width: 450px) {
        font-size: 0.75rem;
        line-height: 1.125rem;
      }
    }
    th {
      border-width: 1px;
    }
    td {
      border-width: 1px;
      vertical-align: top;
    }
    p.table-of-contents {
      line-height: 1.875rem;
    }
    li {
      margin: 10px 0;
    }
  }
  &.size-guide-modal {
    padding: 30px;
    @media only screen and (max-width: 991px) {
      padding: 20px;
    }
  }
  .size-chart-table {
    background-color: var(--white);
    th,
    td {
      text-align: center;
      padding: 10px;
      &.size-type-label {
        color: var(--white);
        font-weight: 700;
        background-color: var(--dark-grey);
        border: 1px solid var(--dark-grey);
        span {
          display: inline-block;
          background-color: var(--yellow);
          color: var(--dark-grey);
          border-radius: 2px;
          padding: 0px 6px;
          font-weight: 700;
          margin-left: 5px;
          line-height: 150%;
          &.reg {
            background-color: var(--green);
            color: var(--white);
          }
        }
      }
    }
    th {
      background-color: var(--green);
      border: 1px solid var(--green);
      color: var(--white);
    }
    tr {
      border-left: 1px solid var(--border);
      border-right: 1px solid var(--border);
      td.size-label,
      strong {
        font-weight: 700;
      }
      &:nth-child(even) {
        border-top: 1px solid var(--border);
        border-bottom: 1px solid var(--border);
      }
      &:last-child {
        border-bottom: 1px solid var(--border) !important;
      }
      &.empty-row {
        background-color: transparent !important;
        border-top: 0 !important;
        border-bottom: 0;
      }
      &.bottom-border {
        border-bottom: 1px solid var(--border);
      }
    }
    @media only screen and (max-width: 767px) {
      font-size: 0.875rem;
    }
  }
  &.large {
    h2 {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 3.125rem;
      font-weight: 300;
      line-height: 3.75rem;
      font-family: "Damion", sans-serif;
      color: var(--dark-grey);
      text-align: center;
      padding: 0;
      margin: 40px 0 20px 0;
    }
    @media only screen and (max-width: 991px) {
      h2 {
        margin: 30px 0 20px 0;
      }
    }
    @media only screen and (max-width: 599px) {
      h2 {
        font-size: 2.5rem;
        line-height: 3.125rem;
      }
    }
    @media only screen and (max-width: 499px) {
      h2 {
        font-size: 1.875rem;
        line-height: 2.5rem;
      }
    }
  }
  .designs-container {
    display: grid;
    min-height: calc(var(--vh, 1vh) * 100);
    button {
      cursor: pointer;
      padding: 0px;
      border: none;
      background-color: transparent;
      position: relative;
      img {
        width: 100%;
        padding: 5px;
      }
      &:focus-visible {
        outline: 3px solid var(--orange-highlight);
        outline-offset: -3px;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(246, 139, 31, 0.15);
          pointer-events: none;
          z-index: 1;
        }
        img {
          filter: contrast(1.15);
        }
      }
    }
    @media only screen and (max-width: 767px) {
      grid-template-columns: 1fr 1fr;
    }
    @media only screen and (min-width: 768px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
    @media only screen and (min-width: 992px) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    @media only screen and (min-width: 1200px) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
    @media only screen and (min-width: 1365px) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    }

    @media only screen and (max-width: 599px) {
      h2 {
        font-size: 2.5rem;
        line-height: 3.125rem;
      }
    }
    @media only screen and (max-width: 499px) {
      h2 {
        font-size: 1.875rem;
        line-height: 2.5rem;
      }
    }
  }
  .loading-screen {
    display: none;
    background-color: rgba(83, 85, 90, 0.75);
    position: fixed;
    height: calc(var(--vh, 1vh) * 100);
    width: 100vw;
    top: 0;
    left: 0;
  }

  .loadingImages {
    aspect-ratio: 1/1;
    gap: 0;
    img {
      display: none;
    }
    column-gap: 0;
    display: flex;
    justify-content: center;
    .loading-screen {
      display: block;
      .loading-bar {
        position: absolute;
        top: calc(50vh - 10px);
        border-radius: 5px;
        left: 25vw;
        width: 50vw;
        height: 20px;
        background-color: var(--mid-grey);
        overflow: hidden;
        .loading-bar-progress {
          background-color: var(--yellow);
          height: 20px;
        }
      }
    }
  }
`;

export const AccountTemplate = styled(Container)`
  max-width: 1200px;
  margin-top: 50px;
  .account-flex-wrapper {
    display: flex;
    width: 100%;
    justify-content: space-between;
    .account-info {
      border-radius: 5px;
      color: var(--dark-grey);
      width: fit-content;
      white-space: nowrap;
      .name {
        font-size: 1.125rem;
        font-weight: 700;
      }
      .logout {
        margin-top: 12px;
      }
      .account-buttons {
        margin-top: 20px;
        button {
          width: 100%;
          &:focus-visible {
            outline-offset: 3px;
          }
        }
      }
    }
    .order-history {
      background-color: var(--off-white);
      border: 1px solid var(--border);
      width: 100%;
      border-radius: 5px;
      margin-right: 50px;
      overflow: hidden;
    }
    @media only screen and (max-width: 991px) {
      flex-direction: column-reverse;
      .account-info {
        margin: 0 auto 30px auto;
        text-align: center;
        .account-buttons {
          display: flex;
          margin-top: 10px;
          button {
            margin: 5px;
          }
        }
      }
    }
    @media only screen and (max-width: 499px) {
      .order-history-buttons {
        margin-top: 10px;
      }
    }
  }
  &.no-orders {
    flex-grow: 1;
    display: flex;
    .order-history {
      display: flex;
      flex-direction: column;
      justify-content: center;
      h1 {
        margin: 0;
        padding: 0;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 700;
        font-size: 0.9rem;
      }
      p {
        text-align: center;
        margin-top: 10px;
      }
    }
  }
`;

export const CartTemplate = styled(Container)`
  max-width: 1200px;
  margin-top: 30px;
  .cartQuantity {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .stock-note {
      margin-left: 20px;
    }
  }
  .cart-bottom-boxes {
    margin-top: 50px;
    .size-guide {
      background-color: var(--green);
      span {
        display: block;
        margin-bottom: 15px;
      }
      @media only screen and (max-width: 991px) {
        margin-bottom: 20px;
      }
    }
    .cart-checkout-box {
      background-color: var(--dark-grey);
      .cart-total {
        margin-bottom: 15px;
        span {
          font-weight: 700;
          margin-left: 20px;
        }
      }
    }
    .size-guide,
    .cart-checkout-box {
      color: var(--white);
      border-radius: 5px;
      padding: 30px;
      font-size: 1.125rem;
      text-align: center;
      @media only screen and (max-width: 499px) {
        font-size: 1rem;
        strong {
          display: block;
        }
      }
    }
    @media only screen and (min-width: 500px) {
      .size-guide-button,
      .checkout-button {
        width: 50%;
        margin: 0 auto;
      }
    }
    @media only screen and (min-width: 992px) {
      display: flex;
      justify-content: space-between;
      & > div {
        &:first-child {
          width: 65%;
          margin-right: 10px;
        }
        &:last-child {
          width: 35%;
          margin-left: 10px;
        }
      }
      .size-guide-button {
        width: fit-content;
        margin: 0 auto;
        min-width: 200px;
      }
      .checkout-button {
        width: fit-content;
        margin: 0 auto;
        min-width: 200px;
      }
    }
  }
`;

export const LoaderStyles = styled.div`
  overflow: hidden;
  touch-action: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  background-color: var(--dark-grey);
  z-index: 1000;
  font-size: 1.875rem;
  .gg-logo {
    width: 80px;
  }
`;

export const CustomerShipping = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  padding: 30px;
  border-bottom: 1px solid var(--border);
  & > div {
    width: 50%;
    padding: 20px;
    border: 1px solid var(--border);
    border-radius: 5px;
    strong {
      color: var(--dark-grey);
    }
    &:first-child {
      margin-right: 15px;
    }
    &:last-child {
      margin-left: 15px;
    }
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    padding: 20px;
    & > div {
      width: 100%;
      &:first-child {
        margin-right: 0;
        margin-bottom: 20px;
      }
      &:last-child {
        margin-left: 0;
      }
    }
  }
`;

export const Empty = styled.div`
  width: 50%;
  margin: 20px auto;
  text-align: center;
`;

export const EmptyCart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--white);
  border-radius: 5px;
  margin: 65px 20px 0 20px;
  width: calc(100% - 40px);
  box-sizing: border-box;
  @media only screen and (min-width: 540px) {
    margin: 65px auto 0 auto;
    width: 500px;
  }
`;

export const VerifyEmail = styled(Empty)`
  width: 100%;
  .logout {
    display: inline-block;
  }
`;

export const CheckoutStyles = styled.div`
  #payment-message {
    color: var(--danger);
    font-size: 1rem;
    line-height: 1.25rem;
    padding: 8px 20px;
    border-radius: 5px;
  }

  .placeOrderButtonWithMessage {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      &:focus-visible {
        outline: 2px solid var(--dark-grey);
        outline-offset: 2px;
      }
    }
    span.loading {
      visibility: hidden;
    }
    i {
      position: absolute;
      color: var(--white);
      font-size: 1.5rem;
    }
  }

  button {
    background: var(--green);
    font-family: "Figtree", sans-serif;
    color: var(--white);
    border-radius: 100px;
    border: 0;
    padding: 8px 20px;
    font-size: 0.75rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 700;
    cursor: pointer;
    display: block;
    width: auto;
    flex-shrink: 0;
    margin-left: auto;
  }

  button:disabled {
    opacity: 0.5;
    cursor: default;
  }

  .spinner,
  .spinner:before,
  .spinner:after {
    border-radius: 50%;
  }

  .spinner {
    color: var(--white);
    font-size: 1.375rem;
    text-indent: -99999px;
    margin: 0px auto;
    position: relative;
    width: 20px;
    height: 20px;
    box-shadow: inset 0 0 0 2px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }

  .spinner:before,
  .spinner:after {
    position: absolute;
    content: "";
  }

  .spinner:before {
    width: 10.4px;
    height: 20.4px;
    background: var(--green);
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    -webkit-transform-origin: 10.4px 10.2px;
    transform-origin: 10.4px 10.2px;
    -webkit-animation: loading 2s infinite ease 1.5s;
    animation: loading 2s infinite ease 1.5s;
  }

  .spinner:after {
    width: 10.4px;
    height: 10.2px;
    background: var(--green);
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    -webkit-transform-origin: 0px 10.2px;
    transform-origin: 0px 10.2px;
    -webkit-animation: loading 2s infinite ease;
    animation: loading 2s infinite ease;
  }

  @keyframes loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export const FooterStyles = styled.div`
  background-color: var(--white);
  font-size: 0.8125rem;

  div.top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > div {
      @media only screen and (min-width: 992px) {
        width: 33.333%;
      }
      &.policies {
        text-align: right;
      }
    }
    .questions {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin: 0 10px;
      }
      @media only screen and (max-width: 991px) {
        order: 3;
      }
      @media only screen and (max-width: 1099px) {
        flex-direction: column;
      }
    }
  }

  div.bottom-bar {
    display: flex;
    justify-content: center;
    background-color: var(--dark-grey);
    color: var(--mid-grey);
    align-items: center;
    img {
      display: block;
      margin: 0 5px;
    }
    div {
      display: flex;
    }
    div.copyright {
      font-weight: 700;
      align-items: center;
      img {
        width: 50px;
      }
    }
    div.social {
      align-items: center;
      a {
        color: var(--mid-grey);
        margin: 0 6px;
        font-size: 1.5rem;
      }
      span {
        margin-right: 10px;
      }
    }
    div.copyright > div {
      margin: 0 6px;
    }
    @media only screen and (max-width: 991px) {
      div.copyright {
        padding: 8px;
      }
      div.social {
        flex-direction: column;
        padding: 8px;
        span {
          display: none;
        }
      }
      img {
        margin: 0;
        margin-bottom: 10px;
      }
    }

    @media only screen and (max-width: 767px) {
      flex-direction: column;
      div.copyright {
        flex-direction: column;
        align-items: center;
      }
    }
  }

  span {
    font-weight: 700;
  }

  a {
    margin: 0 8px;
    &:focus-visible {
      border: none;
      background-color: rgba(246, 139, 31, 0.15);
      box-shadow: 0 0 0 10px rgba(246, 139, 31, 0.15);
      outline: 2px solid var(--orange);
      outline-offset: 5px;
      border-radius: 5px;
    }
  }

  div.top-bar,
  div.bottom-bar {
    padding: 20px;
  }

  @media only screen and (max-width: 991px) {
    div.top-bar,
    div.bottom-bar {
      flex-direction: column;
    }
    div.top-bar {
      & > div {
        padding: 8px 0;
      }
    }
  }
  @media only screen and (min-width: 768px) {
    div.top-bar,
    div.bottom-bar {
      padding: 20px 30px;
    }
  }
  @media only screen and (min-width: 1366px) {
    div.top-bar,
    div.bottom-bar {
      padding: 30px 40px;
    }
  }
`;

export const Refund = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
  &.view-returns-template {
    flex-wrap: wrap;
    align-items: stretch;
  }
  .return-status-timeline {
    border: 1px solid var(--border);
    border-radius: 5px;
    width: 100%;
    flex-basis: 100%;
    display: flex;
    justify-content: space-between;
    padding: 20px 0 10px 0;
  }
  .return-status-step {
    flex: 1;
    color: var(--mid-grey);
    font-weight: 300;
    text-align: left;
  }
  .return-status-step.active {
    color: var(--dark-grey);
    font-weight: 700;
  }
  .return-status-top-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .return-status-circle {
    width: 14px;
    height: 14px;
    border: 2px solid var(--dark-grey);
    border-radius: 50%;
    background-color: var(--white);
    display: inline-block;
    flex-shrink: 0;
  }
  .return-status-step.active .return-status-circle {
    background-color: var(--green);
  }
  .return-status-line {
    height: 2px;
    background-color: var(--dark-grey);
    flex: 1;
  }
  .return-status-label {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.125rem;
    width: 100%;
    text-align: center;
    padding: 0 10px;
  }

  &:last-child {
    margin-bottom: 0;
  }
  .return-products {
    flex-grow: 1;
    border: 1px solid var(--border);
    border-radius: 5px;
    padding: 20px;
  }
  .refund-products {
    width: 100%;
  }
  .return-details {
    background-color: var(--off-white);
    border: 1px solid var(--border);
    border-radius: 5px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-weight: 300;
    align-self: stretch;
    padding: 20px;
    min-width: 200px;
    & > div {
      font-size: 0.875rem;
      line-height: 1.5rem;
      padding: 10px 0;
      span {
        font-weight: 700;
        font-size: 1.125rem;
      }
      &.return-label {
        button {
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
    @media only screen and (max-width: 991px) {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-around;
      & > div {
        font-size: 0.75rem;
        font-weight: 700;
        span {
          font-size: 1rem;
        }
        &.return-label {
          width: 100%;
          & > div {
            width: fit-content;
            margin: 0 auto;
          }
        }
      }
    }
  }

  .return-product {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 20px 10px 0;
    margin-bottom: 0;
    @media only screen and (max-width: 991px) {
      padding-right: 0;
    }
    @media only screen and (max-width: 449px) {
    }
  }
  .total {
    text-align: center;
    font-weight: 700;
    border-top: 1px solid var(--border);
    padding-top: 20px;
    padding-bottom: 5px;
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .cost {
    font-weight: 700;
  }
  img {
    margin-right: 0 !important;
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 20px;
    border-bottom: 0;
    border-radius: 5px;
    background-color: var(--white) !important;
    .return-details {
      padding: 10px 20px;
    }
  }
`;
